import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import StatBlock from '../_partials/StatBlock';
import s from './Status.scss';
export var StatusDetails = function (_a) {
    var deviation = _a.deviation, textContent = _a.deviation.textContent;
    if (!textContent) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement(SubmissionDetails, { deviation: deviation, className: s['details-block'] }),
        React.createElement(StatBlock, { deviation: deviation })));
};
StatusDetails.displayName = 'StatusDetails';
export default StatusDetails;
//# sourceMappingURL=Status.js.map